import { HOUR, Logger, type RoleGetInput, type RoleGetSuccess, type RoleId } from '@terros/common'
import { type GetHookResponse } from '../hooks'
import { roleKey } from '../keys'
import { useTantalimQuery } from '../query'

const logger = new Logger('useRole')
const EMPTY_ROLE: RoleId = 'Role.EMPTY_ROLE'

export function useRole(input: Partial<RoleGetInput>, enabled = true): GetHookResponse<RoleGetSuccess> {
  const { roleId = EMPTY_ROLE } = input
  logger.verbose('calling useRole', roleId)
  return useTantalimQuery<RoleGetInput, RoleGetSuccess, RoleGetSuccess>({
    url: '/role/get',
    queryKey: roleKey(roleId, input),
    input: {
      ...input,
      roleId,
    },
    convertResponse: (data) => data,
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled: roleId !== EMPTY_ROLE && enabled,
    },
  })
}
